
<div
    [formGroup]="form"
    class="agpr-brandCustomInfo"
>
    <div class="agpr-brandCustomInfo-header">
        <label class="agpr-brandCustomInfo-header-label">
            {{ ( config.label ?? '' ) | localize }}
        </label>
        @if (!actions?.length) {
            <agpr-button
                [id]="id + '_add'"
                [style]="buttonTypes.icon"
                [icon]="'fa-regular fa-duotone fa-square-plus'"
                (click)="add()"
                [tooltip]="'Common.brandInformation.customInfo.add'"
                [tooltipPosition]="'left'"
                [disabled]="disabled || value.length >= maxLimit"
            ></agpr-button>
        }
    </div>

    @if (customInfo.controls.length) {
        <ul
            formArrayName="customInfo"
            class="agpr-brandCustomInfo-list"
            agprListKeyboardNavigation
            [list]="value"
        >
            @for (group of customInfo.controls; track group; let i = $index;) {
                <li
                    #listItem
                    [formGroupName]="i"
                    class="agpr-brandCustomInfo-listItem agpr-contextMenu-parent"
                >
                    <div class="agpr-brandCustomInfo-card">
                        @if (actions?.length) {
                            <div>
                                <agpr-dropdown
                                    formControlName="infoType"
                                    [id]="id + '_type_' + i"
                                    [label]="config.typeLabel ?? ''"
                                    [placeholder]="config.typePlaceholder ?? ''"
                                    [options]="group.typeOptions ?? []"
                                    [bindToValue]="true"
                                    (change)="onTypeChange(group, $event.value)"
                                ></agpr-dropdown>
                            </div>
                        }

                        @if (!actions?.length || group.isCustomType) {
                            <div>
                                <agpr-text-input
                                    formControlName="title"
                                    [id]="id + '_title_' + i"
                                    [label]="config.titleLabel ?? ''"
                                    [placeholder]="config.titlePlaceholder ?? ''"
                                    [required]="!!config.titleRequired"
                                    [bottomMargin]="false"
                                ></agpr-text-input>
                                @if (group.hasTitleError) {
                                    <agpr-form-message
                                        [id]="id + '_emptyTitleError'"
                                        [marginBottom]="0"
                                    >
                                        {{ ( config.titleErrorMessage ?? '' ) | localize }}
                                    </agpr-form-message>
                                }
                            </div>
                        }

                        <div>
                            @if (config.useTextArea) {
                                <agpr-textarea-input
                                    formControlName="info"
                                    [id]="id + '_info_' + i"
                                    [label]="actions?.length ? '' : (config.infoLabel ?? '')"
                                    [placeholder]="config.infoPlaceholder ?? ''"
                                    [rows]="5"
                                    [required]="!!config.infoRequired"
                                    [bottomMargin]="false"
                                ></agpr-textarea-input>
                            } @else {
                                <agpr-text-input
                                    formControlName="info"
                                    [id]="id + '_info_' + i"
                                    [label]="actions?.length ? '' : (config.infoLabel ?? '')"
                                    [placeholder]="config.infoPlaceholder ?? ''"
                                    [required]="!!config.infoRequired"
                                    [bottomMargin]="false"
                                ></agpr-text-input>
                            }
                            @if (group.hasInfoError) {
                                <agpr-form-message
                                    [id]="id + '_emptyInfoError'"
                                    [marginBottom]="0"
                                >
                                    {{ ( config.infoErrorMessage ?? '' ) | localize }}
                                </agpr-form-message>
                            }
                        </div>
                    </div>
                    <div class="agpr-contextMenu top right">
                        <agpr-button
                            [id]="id + '_remove_' + i"
                            class="agpr-brandCustomInfo-removeButton"
                            [style]="buttonTypes.contextMenu"
                            [icon]="'fa-regular fa-duotone fa-square-xmark'"
                            [tooltip]="'Core.button.remove'"
                            [tooltipPosition]="'left'"
                            (click)="remove(i)"
                            [disabled]="disabled"
                        ></agpr-button>
                    </div>
                </li>
            }
        </ul>
    } @else {
        <agpr-message
            [id]="id + '_noCusomInfoMessage'"
            class="agpr-brandCustomInfo-noCusomInfoMessage"
            [severity]="messageSeverity.noContent"
            [bottomMargin]="false"
        >
            {{ ( config.placeholder ?? '' ) | localize}}
        </agpr-message>
    }

    @if (actions?.length) {
        <agpr-button
            [id]="id + '_addAdditionalInfo'"
            class="agpr-brandCustomInfo-addButton"
            [style]="buttonTypes.tertiary"
            label="Common.brandInformation.customInfo.addAdditional"
            (click)="add()"
            [disabled]="disabled || value.length >= maxLimit"
        ></agpr-button>
    }
</div>

